import React from 'react';

import  Facebook  from '../images/facebook.png';
import  Instagram from '../images/instagram.png';
import  Tiktok  from '../images/tiktok.png';
import '../styles/AppFooter.css';

const AppFooter = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content px-3 px-md-5">
        <div className="footer-left">
          <h2 className="footer-brand">DeTitta</h2>
          <p className="footer-copyright">
            © 2026 Grupo JDT — Todos los derechos reservados.
          </p>
        </div>

        <div className="footer-right">
          <div className="social-icons">
            <a
              href="https://www.instagram.com/detittamotos/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Instagram"
            >
              <img
                src={Instagram}
                alt="Instagram"
                height="36"
                className="d-inline-block align-top"
              />
            </a>
            <a
              href="https://www.facebook.com/detittamotos"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Facebook"
            >
              <img
                src={Facebook}
                alt="Facebook"
                height="36"
                className="d-inline-block align-top"
              />
            </a>
            <a
              href="https://www.tiktok.com/@detittamotos?lang=es"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="TikTok"
            >
              <img
                src={Tiktok}
                alt="TikTok"
                height="36"
                className="d-inline-block align-top"
              />
            </a>
          </div>
          <p className="footer-developed">
            Desarrollado por <a href="https://www.carbon-base.com/?utm_source=detittamotos" target="_blank" rel="noopener noreferrer" className="carbonbase">Carbonbase</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
